import { render, staticRenderFns } from "./FilesSidebarTabApp.vue?vue&type=template&id=ffd88b88&scoped=true&"
import script from "./FilesSidebarTabApp.vue?vue&type=script&lang=js&"
export * from "./FilesSidebarTabApp.vue?vue&type=script&lang=js&"
import style0 from "./FilesSidebarTabApp.vue?vue&type=style&index=0&id=ffd88b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd88b88",
  null
  
)

export default component.exports